import { Injectable } from '@angular/core';
import { LoggingService } from '../logging/logic/logging.service';
import { IMSId, IMSObject } from 'src/app/_model/ims-object';
import { Servicejob } from 'src/app/_model/servicejob';
import { ServicejobsService } from '../servicejobs/logic/servicejobs.service';

/**
 * Interface Definition for a ToolbarContent
 */
@Injectable({
  providedIn: 'root',
})
export class UpdateModelObjectService {

  // Lifecycle
  constructor(
    private servicejobService: ServicejobsService,
    private logger?: LoggingService,
  ) { }

  // Public Functions
  public async updateServiceJob(sjobId: IMSId, fieldNameToNewValueMap: Map<string, any>): Promise<any> {
    this.logger.log(this.constructor.name, ' updating Servicejob with parameters -> sjobId:', sjobId, ' fieldNameToNewValueMap:', fieldNameToNewValueMap)
    let sjob: Servicejob = this.servicejobService.getServiceJobById(sjobId)
    if (sjob) {
      sjob.updateObject(fieldNameToNewValueMap)
      await this.servicejobService.updateServicejob(sjob)
    } else {
      this.logger.log(this.constructor.name, ' could not find sjob with Id: ', sjobId)
    }
  }

  public async updateModelObject(imsObject: IMSObject, fieldNameToNewValueMap: Map<string, any>) {
    if (imsObject == undefined || fieldNameToNewValueMap == undefined) {
      return
    }
    if (imsObject.id?.objRef == 'ims/ServiceJob') {
      await this.updateServiceJob(imsObject.id, fieldNameToNewValueMap)
    } else {
      this.logger.log(this.constructor.name, ' updatemodelobject not implemented for objref:', imsObject.id?.objRef)
    }
  }
  // Private Functions

}
